// extracted by mini-css-extract-plugin
export default {"mainContReview":"Reviews_mainContReview__hmB8L","pro":"Reviews_pro__uHGMZ","rDiv":"Reviews_rDiv__dncq-"};